/**
 * Mock data for PACKOUT Wall Plate Builder configurator
 * Product ID: 338909191
 * This matches the exact structure from the real API response
 */
export const mockPackoutConfiguratorData = {
  brand: 'Milwaukee',
  productName: 'PACKOUT Wall Plate Builder',
  siteProductName: 'PACKOUT Wall Plate Builder',
  categoryLabel: 'Barn Doors',
  mainImageUrl: 'https://blinds.homedepot.com/product-images/d91edcca-9661-ec11-949a-0a986990730e.jpg',
  productType: 'Portable Storage',
  productId: 711698,
  variantId: 0,
  partnerProductId: 338909191,
  groups: [
    {
      name: 'Ungrouped',
      sequenceNumber: 0,
      options: [
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'WALL_PLATE_WALL_PLATES',
          isInternalOnly: false,
          shortLabel: 'WALL PLATES',
          longLabel: 'WALL PLATES',
          optionType: null,
          description: '',
          id: 15584,
          presentationName: 'WALL PLATES',
          "choices": [
              {
                  "id": 265405,
                  "mediaUrl": "https://blinds.homedepot.com/product-images/c03647e2-9acc-f011-848f-0afffee37a07.png",
                  "media": {
                      "alternateText": "wallplate large",
                      "caption": null,
                      "mediaOwner": null
                  },
                  "isActive": true,
                  "internalName": "_PACKOUT_LARGE_WALL_PLATE",
                  "shortLabel": "PACKOUT LARGE WALL PLATE",
                  "longLabel": "PACKOUT LARGE WALL PLATE",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 0.0,
                  "sequence": 1,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      {
                          "metaDataId": 10838,
                          "name": "Sku",
                          "value": "329930935",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18567,
                          "name": "isBase",
                          "value": "true",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18644,
                          "name": "height",
                          "value": "20",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 18645,
                          "name": "width",
                          "value": "30.75",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 186481,
                          "name": "anchorpointDimensions",
                          "value": {
                              "width":3.7,
                              "height":3.8
                            },
                          "type": "json"
                      },
                      {
                          "metaDataId": 186482,
                          "name": "anchorpointOffsets",
                          "value": {
                              "top":4.2,
                              "left":1.5,
                              "footPrint":2.45,
                              "row":0.4,
                              "column": 0.4
                            },
                          "type": "json"
                      },
                      {
                          "metaDataId": 186483,
                          "name": "anchorpointBuildPattern",
                          "value": {
                              "type":"grid",
                              "rows":3,
                              "footPrints":3,
                              "columnsPerFootPrint":2
                            }
                          ,
                          "type": "json"
                      },
                      {
                          "metaDataId": 186484,
                          "name": "anchorpointType",
                          "value": "cleat",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18661,
                          "name": "componentType",
                          "value": "mount-surface",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18940,
                          "name": "gridColumns",
                          "value": "3",
                          "type": "int"
                      },
                      {
                          "metaDataId": 18941,
                          "name": "gridRows",
                          "value": "1",
                          "type": "int"
                      }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },
              {
                  "id": 265412,
                  "mediaUrl": "https://blinds.homedepot.com/product-images/d0301aef-9acc-f011-848f-0afffee37a07.png",
                  "media": {
                      "alternateText": "wallplate compact",
                      "caption": null,
                      "mediaOwner": null
                  },
                  "isActive": true,
                  "internalName": "_PACKOUT_COMPACT_WALL_PLATE",
                  "shortLabel": "PACKOUT COMPACT WALL PLATE",
                  "longLabel": "PACKOUT COMPACT WALL PLATE",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 0.0,
                  "sequence": 2,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      {
                          "metaDataId": 10830,
                          "name": "Sku",
                          "value": "329930718",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18568,
                          "name": "isBase",
                          "value": "true",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18642,
                          "name": "height",
                          "value": "20",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 18643,
                          "name": "width",
                          "value": "10.25",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 18654,
                          "name": "anchorPointConfig",
                           "value": "{\"width\":3.7,\"height\":3.8,\"type\":\"cleat\",\"offSets\":{\"top\":4.2,\"left\":1.5,\"footPrint\":2.4,\"row\":0.4,\"column\": 0.4},\"buildPattern\":{\"type\":\"grid\",\"rows\":3,\"footPrints\":1,\"columnsPerFootPrint\":2}}",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18752,
                          "name": "componentType",
                          "value": "mount-surface",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18945,
                          "name": "gridRows",
                          "value": "1",
                          "type": "int"
                      },
                      {
                          "metaDataId": 18946,
                          "name": "gridColumns",
                          "value": "1",
                          "type": "int"
                      }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },

              // ── Mock: WallStorage 2-plate horizontal bundle ───────────────────
              // Design ID maps to mock-data/bundle-designs/wallStorage-bundle.mock.js
              // Footprint: 6 cols × 1 row  (two 3-wide plates side by side)
              {
                  "id": 280001,
                  "mediaUrl": "https://blinds.homedepot.com/product-images/c03647e2-9acc-f011-848f-0afffee37a07.png",
                  "media": { "alternateText": "2-Plate Wall Bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_WALL_BUNDLE_2PLATE",
                  "shortLabel": "2-Plate Bundle (mock)",
                  "longLabel": "PACKOUT 2×Large Wall Plate Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 78.91,
                  "sequence": 3,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28001, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28002, "name": "BundleDesign",  "value": "8f0af0eb-0000-0000-0000-mock00000001",     "type": "string" },
                      { "metaDataId": 28003, "name": "gridColumns",   "value": "6",                                       "type": "int" },
                      { "metaDataId": 28004, "name": "gridRows",      "value": "1",                                       "type": "int" },
                      { "metaDataId": 28005, "name": "width",         "value": "61.50",                                   "type": "decimal" },
                      { "metaDataId": 28006, "name": "height",        "value": "20",                                      "type": "decimal" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },

              // ── Mock: VehicleStorage (Rack) bundle with partial null SKUs ─────
              // Design ID maps to mock-data/bundle-designs/vehicleStorage-bundle.mock.js
              // floorOnly=true → placed on floor, not wall grid
              {
                  "id": 280002,
                  "mediaUrl": "https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_222222_1.png",
                  "media": { "alternateText": "Rack Bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_RACK_BUNDLE",
                  "shortLabel": "Rack Bundle (mock)",
                  "longLabel": "PACKOUT Rack + Frame Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 570.79,
                  "sequence": 4,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28011, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28012, "name": "BundleDesign",  "value": "15a265db-0000-0000-0000-mock00000002",    "type": "string" },
                      { "metaDataId": 28013, "name": "floorOnly",     "value": "true",                                    "type": "string" },
                      { "metaDataId": 28014, "name": "width",         "value": "27.30",                                   "type": "decimal" },
                      { "metaDataId": 28015, "name": "height",        "value": "35.95",                                   "type": "decimal" },
                      { "metaDataId": 28016, "name": "dimensions",    "value": "27.30x35.95",                             "type": "string" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },
              // Mock: VehicleStorage Hardbundle
              {
                  "id": 280003,
                  "mediaUrl": "https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_222222_1.png",
                  "media": { "alternateText": "Rack Bundle Hard bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_RACK_BUNDLE",
                  "shortLabel": "Rack Bundle (mock)",
                  "longLabel": "PACKOUT Rack + Frame Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 570.79,
                  "sequence": 4,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28011, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28012, "name": "BundleDesign",  "value": "15a265db-0000-0000-0000-mock00000003",    "type": "string" },
                      { "metaDataId": 28013, "name": "floorOnly",     "value": "true",                                    "type": "string" },
                      { "metaDataId": 28014, "name": "width",         "value": "27.30",                                   "type": "decimal" },
                      { "metaDataId": 28015, "name": "height",        "value": "35.95",                                   "type": "decimal" },
                      { "metaDataId": 28016, "name": "dimensions",    "value": "27.30x35.95",                             "type": "string" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },

              // ── Mock: WallStorage 2-plate loaded bundle ───────────────────────
              // Design ID maps to mock-data/bundle-designs/wallStorage-bundle-loaded.mock.js
              // Footprint: 6 cols × 1 row (two 3-wide plates side by side, pre-loaded
              // with a rack, cabinet, organizer and hooks)
              {
                  "id": 280004,
                  "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/711698_265405_0?fmt=png",
                  "media": { "alternateText": "2-Plate Loaded Wall Bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_WALL_BUNDLE_2PLATE_LOADED",
                  "shortLabel": "2-Plate Loaded Bundle (mock)",
                  "longLabel": "PACKOUT 2×Large Wall Plate Loaded Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 249.97,
                  "sequence": 5,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28021, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28022, "name": "BundleDesign",  "value": "8f0af0eb-0000-0000-0000-mock00000004",     "type": "string" },
                      { "metaDataId": 28023, "name": "gridColumns",   "value": "6",                                       "type": "int" },
                      { "metaDataId": 28024, "name": "gridRows",      "value": "1",                                       "type": "int" },
                      { "metaDataId": 28025, "name": "width",         "value": "61.50",                                   "type": "decimal" },
                      { "metaDataId": 28026, "name": "height",        "value": "20",                                      "type": "decimal" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              }
          ],
          sequence: 2,
          groupSequence: 2,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'WALL_PLATE_HOOKS',
          isInternalOnly: false,
          shortLabel: 'HOOKS',
          longLabel: 'HOOKS',
          optionType: null,
          description: '',
          id: 15585,
          presentationName: 'HOOKS',
                    "choices": [
                        {
                            "id": 265416,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/fcd74a8e-83d0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_4_SINGLE_STRAIGHT_HOOK",
                            "shortLabel": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                            "longLabel": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10848,
                                    "name": "Sku",
                                    "value": "325001889",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19128,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19129,
                                    "name": "height",
                                    "value": "4",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19242,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1.2,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265417,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/6fffa0a1-83d0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 7-HOOK RACK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_7HOOK_RACK",
                            "shortLabel": "PACKOUT 7-HOOK RACK",
                            "longLabel": "PACKOUT 7-HOOK RACK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 2,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10847,
                                    "name": "Sku",
                                    "value": "325001890",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18870,
                                    "name": "height",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18871,
                                    "name": "width",
                                    "value": "9.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18872,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":0.7,\"left\":-0.6}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265424,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/071b6eb1-8bd0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 9\" STRAIGHT HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_9_STRAIGHT_HOOK",
                            "shortLabel": "PACKOUT 9\" STRAIGHT HOOK",
                            "longLabel": "PACKOUT 9\" STRAIGHT HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 3,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10844,
                                    "name": "Sku",
                                    "value": "320026102",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18889,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18890,
                                    "name": "height",
                                    "value": "8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18891,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":3.5,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265419,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/9eb112ae-71d4-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 6\" CURVED HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_6_CURVED_HOOK",
                            "shortLabel": "PACKOUT 6\" CURVED HOOK",
                            "longLabel": "PACKOUT 6\" CURVED HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 4,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10842,
                                    "name": "Sku",
                                    "value": "320026716",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18886,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18887,
                                    "name": "height",
                                    "value": "9",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18888,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":3.5,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265423,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/14fc5df3-71d4-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT WIDE HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_WIDE_HOOK",
                            "shortLabel": "PACKOUT WIDE HOOK",
                            "longLabel": "PACKOUT WIDE HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 5,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10845,
                                    "name": "Sku",
                                    "value": "320052193",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18734,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":-1.8},\"onePerFootPrint\":true,\"zIndex\":99}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18841,
                                    "name": "height",
                                    "value": "8.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18842,
                                    "name": "width",
                                    "value": "7",
                                    "type": "decimal"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265418,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/5f4ccab9-83d0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 4\" S HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_4_S_HOOK",
                            "shortLabel": "PACKOUT 4\" S HOOK",
                            "longLabel": "PACKOUT 4\" S HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 6,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10841,
                                    "name": "Sku",
                                    "value": "320052375",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19130,
                                    "name": "height",
                                    "value": "7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19131,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19243,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265422,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/203c9ef7-8ad0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 4\" STRAIGHT HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_4_STRAIGHT_HOOK",
                            "shortLabel": "PACKOUT 4\" STRAIGHT HOOK",
                            "longLabel": "PACKOUT 4\" STRAIGHT HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 6,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10839,
                                    "name": "Sku",
                                    "value": "320052829",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19132,
                                    "name": "height",
                                    "value": "4",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19133,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19244,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265420,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/2420bcde-71d4-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 3\" CURVED HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_3_CURVED_HOOK",
                            "shortLabel": "PACKOUT 3\" CURVED HOOK",
                            "longLabel": "PACKOUT 3\" CURVED HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 8,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10843,
                                    "name": "Sku",
                                    "value": "320089458",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18735,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":0.1}}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18819,
                                    "name": "height",
                                    "value": "4",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18820,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },

                        // ── Mock: catalog entries for wallStorage-bundle-loaded.mock.js accessories ──
                        // These choiceIds are referenced by that bundle's DesignDocument.Products[].ChoiceId
                        // but had no matching catalog choice, so bundleChoiceMetadata resolved to {} and
                        // attachConfig was null — getAvailableAnchorPoints bails out with no dropzones
                        // for that product on ANY parent (not just the "other" plate).
                        {
                            "id": 265400,
                            "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/711698_265400_0?fmt=png",
                            "media": { "alternateText": "PACKOUT 5-COMPARTMENT ORGANIZER", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "_PACKOUT_5COMP_LOWPROFILE_ORGANIZER",
                            "shortLabel": "PACKOUT 5-COMPARTMENT ORGANIZER",
                            "longLabel": "PACKOUT 5-Compartment Low-Profile Compact Small Parts Organizer",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 9,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 30001, "name": "Sku", "value": "305821962", "type": "string" },
                                { "metaDataId": 30002, "name": "height", "value": "16.2", "type": "decimal" },
                                { "metaDataId": 30003, "name": "width", "value": "9.8", "type": "decimal" },
                                {
                                    "metaDataId": 30004,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.8,\"left\":-1.2}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265425,
                            "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/711698_265425_0?fmt=png",
                            "media": { "alternateText": "PACKOUT 19.5in CABINET", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "_PACKOUT_CABINET_RED_1PC",
                            "shortLabel": "PACKOUT 19.5in CABINET",
                            "longLabel": "Packout 19.5 in. W x 14.7 in. H x 14.5 in. D Cabinet in Red (1-Piece)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 10,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 30005, "name": "Sku", "value": "320324795", "type": "string" },
                                { "metaDataId": 30006, "name": "height", "value": "14.7", "type": "decimal" },
                                { "metaDataId": 30007, "name": "width", "value": "19.5", "type": "decimal" },
                                {
                                    "metaDataId": 30008,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        }
                    ],
          sequence: 3,
          groupSequence: 3,
          tags: [],
          choiceGroups: []
        },
                        {
                    "isActive": true,
                    "isRequired": false,
                    "isHidden": false,
                    "isVisualized": false,
                    "isDependent": false,
                    "isIndexable": false,
                    "internalName": "WALL_PLATE_KITS",
                    "isInternalOnly": false,
                    "shortLabel": "KITS",
                    "longLabel": "KITS",
                    "optionType": null,
                    "description": "",
                    "id": 15578,
                    "presentationName": "KITS",
                    "choices": [
                        {
                            "id": 265392,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/809b2d20-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265392_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_32PC_RTCHTSCKT_WPKOUT_LP_COMP_ORG",
                            "shortLabel": "32PC RTCHT/SCKT W/PKOUT LP COMP ORG",
                            "longLabel": "32PC RTCHT/SCKT W/PKOUT LP COMP ORG",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 19255,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.8,\"left\":-1.2}}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 10811,
                                    "name": "Sku",
                                    "value": "313127913",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19144,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19145,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265389,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/94ceb302-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265389_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_38_28PC_RTCHTSCKT_SET_IN_PKOUT",
                            "shortLabel": "3/8\" - 28PC RTCHT/SCKT SET IN PKOUT",
                            "longLabel": "3/8\" - 28PC RTCHT/SCKT SET IN PKOUT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10812,
                                    "name": "Sku",
                                    "value": "309586202",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19138,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19139,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19258,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.9,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265395,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/c19c2a45-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265395_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_47PC_12_DR_RTCHTSCKT_SETPACKOUT",
                            "shortLabel": "47PC 1/2\" DR RTCHT/SCKT SET-PACKOUT",
                            "longLabel": "47PC 1/2\" DR RTCHT/SCKT SET-PACKOUT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10827,
                                    "name": "Sku",
                                    "value": "322405466",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19150,
                                    "name": "height",
                                    "value": "16.3",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19151,
                                    "name": "width",
                                    "value": "19.7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19252,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265388,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/a35e968a-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265388_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_CLSA_COMP_PACKOUT_FIRST_AID_KIT",
                            "shortLabel": "CLS-A COMP PACKOUT FIRST AID KIT",
                            "longLabel": "CLS-A COMP PACKOUT FIRST AID KIT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10813,
                                    "name": "Sku",
                                    "value": "321502928",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19136,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19137,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19259,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1.2}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265393,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/9c25d862-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265393_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_CLSB_PACKOUT_FIRST_AID_KIT",
                            "shortLabel": "CLS-B PACKOUT FIRST AID KIT",
                            "longLabel": "CLS-B PACKOUT FIRST AID KIT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10826,
                                    "name": "Sku",
                                    "value": "321502919",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19146,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19147,
                                    "name": "width",
                                    "value": "19.7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19254,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265396,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/3730fd33-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265396_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_106PC_RTCHTSCKT_WPKOUT_LP_ORG",
                            "shortLabel": "106PC RTCHT/SCKT W/PKOUT LP ORG",
                            "longLabel": "106PC RTCHT/SCKT W/PKOUT LP ORG",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 2,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10810,
                                    "name": "Sku",
                                    "value": "313128236",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19152,
                                    "name": "height",
                                    "value": "16.3",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19153,
                                    "name": "width",
                                    "value": "19.7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19251,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-1.8,\"left\":-1.3}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265398,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/4bd074d1-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265398_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_12DR_15PC_SAE_PO_IMP_SCKT_SET",
                            "shortLabel": "1/2DR 15PC SAE PO IMP SCKT SET",
                            "longLabel": "1/2DR 15PC SAE PO IMP SCKT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 4,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10817,
                                    "name": "Sku",
                                    "value": "320203635",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19156,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19157,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19249,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265399,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/9313a3be-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265399_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_38DR_19PC_MM_PO_IMP_SCKT_SET",
                            "shortLabel": "3/8DR 19PC MM PO IMP SCKT SET",
                            "longLabel": "3/8DR 19PC MM PO IMP SCKT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 5,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10831,
                                    "name": "Sku",
                                    "value": "320203602",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19158,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19159,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19248,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265407,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/23f2aeae-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265407_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_38DR_17PC_SAE_PO_IMP_SCKT_SET",
                            "shortLabel": "3/8DR 17PC SAE PO IMP SCKT SET",
                            "longLabel": "3/8DR 17PC SAE PO IMP SCKT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 7,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10832,
                                    "name": "Sku",
                                    "value": "320203501",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19162,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19163,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19246,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.7,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265415,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/5eff76dd-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265415_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_27PC_12_DRIVE_MMANDSAE_PACKOUT_SET",
                            "shortLabel": "27PC 1/2\" DRIVE MM&SAE PACKOUT SET",
                            "longLabel": "27PC 1/2\" DRIVE MM&SAE PACKOUT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 8,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10837,
                                    "name": "Sku",
                                    "value": "320204158",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19164,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19165,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19245,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        }
                    ],
                    "sequence": 4,
                    "groupSequence": 4,
                    "tags": [],
                    "choiceGroups": []
                },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'PACKOUTRackPopularBundles',
          isInternalOnly: false,
          shortLabel: 'Popular Bundles',
          longLabel: 'Looking for good place to start? Start building your system with popular PACKOUT bundles',
          optionType: null,
          description: '',
          id: 15490,
          presentationName: 'Racks',
          choices: [
            {
              id: 264791,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_444444_1.png',
              media: {
                alternateText: '2 Rack Drawer High',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerHigh2',
              shortLabel: '2 Rack Drawer High',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10277,
                  name: 'Sku',
                  value: '337195391',
                  type: 'string'
                },
                {
                  metaDataId: 1028501,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028502,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028503,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028504,
                  name: 'height',
                  value: '63',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028505,
                  name: 'dimensions',
                  value: '27.30x63',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 264792,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_333333_1.png',
              media: {
                alternateText: '2 Rack Drawer Mid',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerMid2',
              shortLabel: '2 Rack Drawer Mid',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 2,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10278,
                  name: 'Sku',
                  value: '337195397',
                  type: 'string'
                },
                {
                  metaDataId: 1028601,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028602,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028603,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028604,
                  name: 'height',
                  value: '44.95',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028605,
                  name: 'dimensions',
                  value: '27.30x44.95',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 264793,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_222222_1.png',
              media: {
                alternateText: '1 Rack Drawer Low',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerLow1',
              shortLabel: '1 Rack Drawer Low',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 3,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10279,
                  name: 'Sku',
                  value: '337195406',
                  type: 'string'
                },
                {
                  metaDataId: 1028701,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028702,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028703,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028704,
                  name: 'height',
                  value: '35.95',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028705,
                  name: 'dimensions',
                  value: '27.30x35.95',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 264794,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_111111_1.png',
              media: {
                alternateText: '1 Rack Drawer High',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerHigh1',
              shortLabel: '1 Rack Drawer High',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 4,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10280,
                  name: 'Sku',
                  value: '337195423',
                  type: 'string'
                },
                {
                  metaDataId: 1028801,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028802,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028803,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028804,
                  name: 'height',
                  value: '55.95',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028805,
                  name: 'dimensions',
                  value: '27.30x55.95',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 4,
          groupSequence: 4,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'CABINET_BASE_CABINETS',
          isInternalOnly: false,
          shortLabel: 'BASE CABINETS',
          longLabel: 'BASE CABINETS',
          optionType: null,
          description: '',
          id: 19001,
          presentationName: 'BASE CABINETS',
          choices: [
            {
              id: 270001,
              mediaUrl: 'https://blinds.homedepot.com/is/image/cabinets/248906/328272163.png',
              media: {
                alternateText: 'Base Cabinet',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: '_BASE_CABINET_36W',
              shortLabel: 'BASE CABINET 36W',
              longLabel: 'BASE CABINET 36W',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'CABINET_BASE_CABINETS',
              metaDataItems: [
                {
                  metaDataId: 29001,
                  name: 'Sku',
                  value: '326492802',
                  type: 'string'
                },
                {
                  metaDataId: 29002,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 29003,
                  name: 'width',
                  value: '36',
                  type: 'decimal'
                },
                {
                  metaDataId: 29004,
                  name: 'height',
                  value: '34.5',
                  type: 'decimal'
                },
                {
                  metaDataId: 29005,
                  name: 'dimensions',
                  value: '36x34.5',
                  type: 'string'
                },
                {
                  metaDataId: 29006,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 5,
          groupSequence: 5,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'CABINET_WALL_CABINETS',
          isInternalOnly: false,
          shortLabel: 'WALL CABINETS',
          longLabel: 'WALL CABINETS',
          optionType: null,
          description: '',
          id: 19002,
          presentationName: 'WALL CABINETS',
          choices: [
            {
              id: 270002,
              mediaUrl: 'https://blinds.homedepot.com/is/image/cabinets/248906/328272755.png',
              media: {
                alternateText: 'Wall Cabinet 36W',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: '_WALL_CABINET_36W',
              shortLabel: 'WALL CABINET 36W',
              longLabel: 'WALL CABINET 36W',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'CABINET_WALL_CABINETS',
              metaDataItems: [
                {
                  metaDataId: 29003,
                  name: 'Sku',
                  value: '328272755',
                  type: 'string'
                },
                {
                  metaDataId: 29004,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 29007,
                  name: 'width',
                  value: '36',
                  type: 'decimal'
                },
                {
                  metaDataId: 29008,
                  name: 'height',
                  value: '42',
                  type: 'decimal'
                },
                {
                  metaDataId: 29009,
                  name: 'dimensions',
                  value: '36x42',
                  type: 'string'
                },
                {
                  metaDataId: 29016,
                  name: 'componentType',
                  value: 'wall-cabinet',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 6,
          groupSequence: 6,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'CABINET_TALL_CABINETS',
          isInternalOnly: false,
          shortLabel: 'TALL CABINETS',
          longLabel: 'TALL CABINETS',
          optionType: null,
          description: '',
          id: 19003,
          presentationName: 'TALL CABINETS',
          choices: [
            {
              id: 270003,
              mediaUrl: 'https://blinds.homedepot.com/is/image/cabinets/248906/328272477.png',
              media: {
                alternateText: 'Tall Cabinet',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: '_TALL_CABINET_18W',
              shortLabel: 'TALL CABINET 18W',
              longLabel: 'TALL CABINET 18W',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'CABINET_TALL_CABINETS',
              metaDataItems: [
                {
                  metaDataId: 29010,
                  name: 'Sku',
                  value: '325948323',
                  type: 'string'
                },
                {
                  metaDataId: 29011,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 29012,
                  name: 'width',
                  value: '30',
                  type: 'decimal'
                },
                {
                  metaDataId: 29013,
                  name: 'height',
                  value: '96',
                  type: 'decimal'
                },
                {
                  metaDataId: 29014,
                  name: 'dimensions',
                  value: '36x96',
                  type: 'string'
                },
                {
                  metaDataId: 29015,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 7,
          groupSequence: 7,
          tags: [],
          choiceGroups: []
        }
      ]
    }
  ],
  visualizedOptions: [],
  choiceValueRanges: null,
  isVisualized: false,
  additionalDetails: null
};

export const packoutProductInfoMockData = {
  ProductId: 711698,
  PartnerProductId: 338909191,
  ProductName: 'PACKOUT Wall Plate Builder',
  Brand: 'Milwaukee',
  IsDraft: false,
  DraftProductLastUpdatedAt: '0001-01-01T00:00:00',
  GalleryImages: [
    {
      ImageUrl: '\\SqlImages\\d91edcca-9661-ec11-949a-0a986990730e.jpg',
      Caption: null
    }
  ],
  Attributes: {
    "Scene7Folder": "Blinds/Modular Tool Storage/711698 - Packout Wall Plate Builder",
    "Matrix": "4:4",
    "MatrixSegments": "{\"Segments\": [{\"Start\":[0,0,0],\"End\":[1,3,0]},{\"Start\":[2,0,0],\"End\":[3,3,0]}]}",
    "DisplayName": "PACKOUT",
    "PortableStorageCallout": "False",
    "GridVizConfig": "{\"renderType\":\"grid\",\"numOfCols\":9,\"numOfRows\":3,\"gridBorderStyle\":\"1px solid #ccc\",\"padding\":3,\"cellWidth\":10.25,\"cellHeight\":20,\"strokeStyle\":\"#808080\",\"lineWidth\":1,\"showGrid\":false}",
    WallDimensions: '{"width":137.25,"height":104}',
  }
};
